// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".home-page {\n  padding-top: 74px;\n  position: relative;\n}\n.home-page .weui-search-bar {\n  padding: 0px 15px;\n}\n.home-page .notices-fixed {\n  width: 100%;\n  position: fixed;\n  top: 73px;\n  left: 0;\n  z-index: 1000;\n}\n.home-page .home-content {\n  padding: 2.66vw;\n  background: #eeeeee;\n}\n.home-page .home-content .goods-list {\n  padding: 0px !important;\n  margin-top: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
